import { icons } from '@/globals/platformIcons';
import { IPlatform } from '@/types';
import Image from 'next/image';
import { useRouter } from 'next/router';
import defaultImage from '../../../public/assets/search-icon.svg';
import { Breadcrumbs } from '../breadcrumbs/breadcrumbs.comp';
import { LocalSearchBox } from '../searchBox/searchBox.comp';
import { StyledHero } from './searchHero.styles';

const Stats = ({ total, query }: { total: number; query?: string }) => {
	if (total <= 0) {
		return <h2>No results {query ? `for "${query}"` : ''}</h2>;
	}

	return (
		<h2>
			<span>{total.toLocaleString()}</span> results available{' '}
			{query ? `for "${query}"` : ''}
		</h2>
	);
};

export const SearchHero = ({
	platform,
	showSearch = true,
	wantedCategory,
	total = 0,
	query,
}: {
	platform?: Partial<IPlatform>;
	showSearch?: boolean;
	wantedCategory?: any;
	total?: number;
	query?: string;
}) => {
	const router = useRouter();

	const appSynonym = platform?.appSynonym || 'app';
	const breadcrumbs = [
		{
			name: 'Discover',
			url: '/',
		},
	];

	if (platform) {
		breadcrumbs.push({
			name: `${platform.displayName}`,
			url: `/${platform.name}`,
		});
		if (router.pathname.includes('results')) {
			breadcrumbs.push({
				name: `Results`,
				url: `/${platform.name}/results`,
			});
		}
		if (wantedCategory) {
			breadcrumbs.push({
				name: `${wantedCategory.displayName}`,
				url: `/${platform.name}/category/${wantedCategory.slug}`,
			});
		}
	} else {
		breadcrumbs.push({ name: `Results`, url: `/results` });
	}

	return (
		<StyledHero>
			<div className="hero-content-container">
				<Breadcrumbs breadcrumbs={breadcrumbs} />
				<h1>
					Discover the best {wantedCategory ? wantedCategory?.displayName : ''}{' '}
					{appSynonym}s for {platform?.displayName || 'your website'}
				</h1>
				<Stats total={total} query={query} />
				{showSearch && platform && (
					<LocalSearchBox
						searchAsYouType={true}
						enableAutoComplete={true}
						platform={platform as any}
					/>
				)}
			</div>
			<div className={`img-wrapper`}>
				{renderSquares()}
				<Image
					className={`${showSearch && 'search-exists'}`}
					width={80}
					height={80}
					src={
						platform
							? (icons as any)[(platform as IPlatform).name]
							: defaultImage
					}
					alt={`${platform?.displayName || 'search'} icon`}
				/>
			</div>
		</StyledHero>
	);
};

function renderSquares() {
	return (
		<svg
			width="347"
			height="281"
			viewBox="0 0 347 281"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="0.771429"
				y="0.771429"
				width="70.4571"
				height="70.4571"
				rx="3.46387"
				fill="#222535"
				stroke="#2A2E42"
				strokeWidth="1.54286"
			/>
			<rect
				x="53.4071"
				y="99.4071"
				width="37.1857"
				height="37.1857"
				rx="1.82815"
				fill="#222535"
				stroke="#2A2E42"
				strokeWidth="0.814286"
			/>
			<rect
				x="287.643"
				y="221.643"
				width="58.7143"
				height="58.7143"
				rx="2.88655"
				fill="#222535"
				stroke="#2A2E42"
				strokeWidth="1.28571"
			/>
			<rect
				x="238.536"
				y="49.5357"
				width="48.9286"
				height="48.9286"
				rx="2.40546"
				fill="#222535"
				stroke="#2A2E42"
				strokeWidth="1.07143"
			/>
			<rect
				x="116.5"
				y="72.5"
				width="137"
				height="137"
				rx="6.73529"
				fill="#222535"
				stroke="#2A2E42"
				strokeWidth="3"
			/>
		</svg>
	);
}
